import React, { Fragment, FunctionComponent, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {
  Navbar,
  Dropdown,
  Row,
  Col,
  Form,
  Breadcrumb,
  Nav,
} from "react-bootstrap";
import VerismaLogo from "../../assets/images/headerImages/VerismaLogo.png";
import QuestionMark from "../../assets/images/headerImages/question-mark.png";
import HomeIcon from "../../assets/images/headerImages/HomeIcon.png";
import returnOutlineLarge from "../../assets/images/tabImages/returnOutlineLarge.png";
import magnifying_glass_small_outline from "../../assets/images/headerImages/magnifying_glass_small_outline.svg";
import { ApiUrl } from "../../services/Network";
import "../header/Header.scss";
import { onChangeDarkMode } from "./HeaderDucks";
import { clearPreviousSearch, getPreferenceValues, returnToSearchRequest, savePreference, setUserPreferences } from '../../components/login/LoginPageDucks';
import { Link } from "react-router-dom";
import {
  resetSelectedHealthOrganizatonDetails, getTransactionSearchResultsRequest, getTransactionSearchResultsReset,
  getInitialsRequest, showReadOnlyTransactionRequest, clearUserLocksActionRequest, getNextQATransaction,
  updateRequestContext,
  openSearchResultRequest
} from "../../components/landingPage/LandingPageDucks";
import NormalTable from '../../common/table/NormalTable/NormalTable';
import { logoutUserRequest, refreshUserRedisCacheRequest } from '../../components/login/LoginPageDucks';
import { getMomentDate } from "../utils/appUtils";
import APIErrorPopUp from '../alertPopup/APIErrorPopUp';
import ErrorMessagePopup from '../alertPopup/ErrorMessagePopup';
import InformationPrompt from '../alertPopup/InformationPrompt';
import NightIcon from '../../assets/images/headerImages/NightIcon.png';
import DayIcon from '../../assets/images/headerImages/DayIcon.png';
import urgent_outline_large from "../../assets/images/urgent_outline_large.svg";
import { onChangeDataEntryTab, resetDataEntryState, getQAErrorsActionCreator, getTransactionDocuments } from '../../components/dataEntryDetails/DataEntryDetailsDucks';
import ReadOnlyTransaction from "./ReadOnlyTransaction";
import { resetRequestContext } from '../../components/landingPage/LandingPageDucks';
import AutoLogoutTimeOut from "../autoLogoutTimeOut/autoLogoutTimeOut";
import UserPreferences from "../modal/UserPreferences";
import LoadingSpinner from "../loadingSpinner/loadingSpinner";
import Preferences from "../../models/preferences";
import {ReviewEntity} from "../../models/assessment";
import {FacilitiesCountsModal} from "../../components/dataEntryDetails/dataEntryComponents/DataEntryDetails";

interface HeaderProps {
  homeText: string[];
  onChangeDarkMode: Function;
  isDarkModeEnabled: boolean;
  name: string,
  resetSelectedHealthOrganizatonDetails: Function,
  logoutUser: Function,
  theme: string,
  alertAPIFailure: number,
  getTransactionSearchResultsRequest?: Function,
  getTransactionSearchResultsReset: () => void,
  transactionSearchResults: any,
  selectedHealthOrganizationDetails?: any,
  selectedFacilityDetails?: FacilitiesCountsModal,
  transactionSearchResultsStatus: number,
  userState: any,
  headerClassName?: any,
  searchPlaceholder?: string,
  searchChanged?: ((term: string) => void),
  assignAPIInfo?: any,
  existingTransactionID?: any,
  openSearchResult: (organizationId: number, requestBufferId: number) => void,
  userPersonalInfo: any,
  onChangeDataEntryTab: (tab: number) => void,
  resetDataEntryState: () => void,
  showReadOnlyTransaction: (transactionId: string) => void,
  resetRequestContext: () => void,
  searchTerm?: string,
  clearUserLocks?: Function,
  getQAFeatureFlagsRequest?: Function,
  finalQaFeature?: string,
  previousSearchParameters?: string,
  previousSearchPage?: number,
  returnToSearch?: Function,
  transactionId?: string,
  clearPreviousSearch: Function,
  reviewEntities?: ReviewEntity[],
  getQAErrors: any,
  getTransactionDocuments: Function,
  getNextQATransaction: Function,
  getNextQATransactionCall: Function,
  changeRequestContext: Function,
  readOnlyTransactionDetails?: any,
  refreshUserRedisCache?: Function,
  preferences?: Preferences,
  preferenceValues?: Array<any>,
  savePreference: (settingValueId: number) => void,
  setPreferences: (preferences: Preferences) => void,
  getPreferenceValues: () => void,
}

const Header: FunctionComponent<HeaderProps> = (props) => {
  const [showSearchGrid, setSearchGrid] = useState(false);
  const [searchText, setSearchText] = useState("")
  const [allowReadOnly, setAllowReadOnly] = useState(false);
  const [searchErrorMessage, setSearchErrorMessage ] = useState("");
  const [showUserPrefs, setShowUserPrefs] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const history = useHistory();
  
  useEffect(() => {
    const getTheme = props.theme;
    if (getTheme === 'dark') {
      props.onChangeDarkMode(true);
    }
  });

  useEffect(() => {
    if(!showSearchGrid){
      props.getTransactionSearchResultsReset && props.getTransactionSearchResultsReset()
    }
  }, [showSearchGrid])

  function onValueChange() {
    props.onChangeDarkMode(!props.isDarkModeEnabled);
  }

  function onAllowReadOnlyChange(){
    setAllowReadOnly(!allowReadOnly);
  }

  function exitTransaction(breadcrumbitem?: number) {
    if (breadcrumbitem === undefined || breadcrumbitem < 3){
      props.clearPreviousSearch();
      props.resetSelectedHealthOrganizatonDetails();
      props.resetRequestContext && props.resetRequestContext();
      props.clearUserLocks && props.clearUserLocks();
      let path = '/home';

      if (breadcrumbitem !== undefined){
        if (breadcrumbitem === 1) {
          path += "#" + props.selectedHealthOrganizationDetails.healthSystem.id.toString();
        } else {
          path += "#" + props.selectedFacilityDetails?.facility.id.toString();
        }
      }

      history?.push(path)
    }
  }

  const sanitizeSearchTerm = (value: string) => {
    setSearchErrorMessage("")

    if(value.replace(" ", "")?.match(/^\d{1,2}([/\-.])\d{1,2}\1\d{2,4}$/g)){
      let tempDate = Date.parse(value)
      if(tempDate < Date.parse("1/1/1753") || tempDate > Date.parse("12/31/9999")){
        setSearchErrorMessage("Invalid date")
        return "";
      }
      if (!isNaN(tempDate)) {
        return value;
      }
    }

    if(value?.match(/-/g)?.length === 1){
      let tempsplitvalue = value.split('-')
      if(tempsplitvalue[0].length < 7 && value[0] === '0'){
        return '100' + value;
      }else{
        return value;
      }
    }

    if(value.length === 10 && /^-?\d+$/.test(value)){
      return value.substring(0, 3) + '-' + value.substring(3, 6) + '-' + value.substring(6, 10)
    }

    return value

  }

  const onClickSearch = () => {
    if (searchText.length < 3) {
      setSearchGrid(false)
    } else {
      
      let searchItem = sanitizeSearchTerm(searchText)
      if(searchItem.length > 0){
        setSearchGrid(true);
        const requestObject = {
          orgId: "",
          searchItem: searchItem,
          allowReadOnly: allowReadOnly
        }
        props.getTransactionSearchResultsRequest && props.getTransactionSearchResultsRequest(requestObject)
      }
    }
  }

  const onSearchTableRowClickHandler = (rowData: any) => {
    if (rowData.isReadOnly === "Yes") {
      props.showReadOnlyTransaction(rowData.transaction)
    } else {
      props.resetDataEntryState();
      setSearchText("");
      props.onChangeDataEntryTab(1);
      props.resetRequestContext();
      const split = rowData.transaction.split("-")
      props.openSearchResult(parseInt(split[0]), parseInt(split[1]));
    }
    props.getTransactionSearchResultsReset();
  }

  const logOut = async () => {
    try {
      setIsLoggingOut(true);
      props.clearPreviousSearch();

      // Clear browser cache
      if ('caches' in window) {
        caches.keys().then((names) => {
          names.forEach(name => caches.delete(name));
        });
      }

      if (props.userState.userAttributes === null) {
        window.location.replace('/');
      } else {
        if (!logOut.called) {
          logOut.called = true;
          await props.logoutUser({ userId: props.userState.userAttributes.id, redirect: () => window.location.replace('/') });
        }
      }
      props.resetDataEntryState && props.resetDataEntryState();

    } catch (error) {
      console.error('Logout error:', error);   
      setIsLoggingOut(false);     
      window.location.replace('/');
    }
  };
  
  // Initialize the flag
  logOut.called = false;

  const onReturnToSearch = () => {
    let organizationId = props.transactionId?.split('-')?.[0];
    let requestBufferId = props.transactionId?.split('-')?.[1];
    props.returnToSearch && props.returnToSearch(organizationId && parseInt(organizationId), requestBufferId && parseInt(requestBufferId), props.previousSearchParameters, props.previousSearchPage);
  }

  function createData(transaction, lastName, firstName, dob, receivedDate, entryDate, requestorName, facilityId, caseNumber, isReadOnly, patientComments, status) {
    return { transaction, lastName, firstName, dob, receivedDate, entryDate, requestorName, facilityId, caseNumber, isReadOnly, patientComments, status};
  }

  const headCellsSearch: { id: string, label: string }[] = [
    { id: 'transaction', label: 'TRANSACTION#' },
    { id: 'lastName', label: 'LAST NAME' },
    { id: 'firstName', label: 'FIRST NAME' },
    { id: 'dob', label: 'DOB' },
    { id: 'receivedDate', label: 'RECEIVED DATE' },
    { id: 'entryDate', label: 'ENTRY DATE' },
    { id: 'requestorName', label: 'REQUESTOR NAME' },
    { id: 'caseNumber', label: 'CASE NUMBER' },
    { id: 'status', label: 'STATUS' }
  ];

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (!props.transactionSearchResults?.length) { 
      setTableData([]) 
    }

    setTableData(props.transactionSearchResults.map(item => {
      return createData(item.transactionID, item.patientLastName, item.patientFirstName, getMomentDate(item.patientDOB), getMomentDate(item.receivedDate), getMomentDate(item.resDataEntryDate), item.requestorName, item.organizationID, item.caseNumber, item.isReadOnly ? "Yes" : "No", item.patientComments, item.status)
    }))
  }, [props.transactionSearchResults])


  const CustomToggle = React.forwardRef(({ children, onClick }: any, ref) => (
    <a
      href="#!"
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >

      {props.userState.userID ?
        <div className='userIcon'>
          {props.userPersonalInfo.firstName && <p className='userInitials'>{`${props.userPersonalInfo.firstName[0]}${props.userPersonalInfo.lastName[0]}`}</p>}
        </div>
        :
        <div className='userIcon'> </div>
      }
      {children}
    </a>
  ));


  const CustomHelpToggle = React.forwardRef(({ children, onClick }: any, ref) => (
    <a
      href="#!"
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <img
        className="roundIcon"
        src={QuestionMark}
        alt="Logo"
      />

      {children}
    </a>
  ));

  function GetNextQATransactionClick() {
    props.resetDataEntryState && props.resetDataEntryState();
    props.changeRequestContext(8);
    props.getNextQATransactionCall();
  }

  const refreshUserCache = () => {
    props.refreshUserRedisCache && props.refreshUserRedisCache();
  }
  
  function openPreferences() {
    if (!props.preferenceValues) {
      props.getPreferenceValues();
    }
    setShowUserPrefs(true);
  }
  
  function savePreferences(preferences: Preferences) {
    props.setPreferences(preferences);
    if (props.preferenceValues) {
      props.savePreference(parseInt(
        props.preferenceValues.find(x => x.settingID == 1).values
        .find(x => x.settingValue.toLowerCase() == preferences.showThumbnails.toString()).settingValueID
      ));
      props.savePreference(parseInt(
        props.preferenceValues.find(x => x.settingID == 2).values
        .find(x => x.settingValue.toLowerCase() == preferences.zoomLevel).settingValueID
      ));
      props.savePreference(parseInt(
        props.preferenceValues.find(x => x.settingID == 3).values
        .find(x => x.settingValue.toLowerCase() == preferences.showBookmarks.toString()).settingValueID
      ));
    }
  }

  return (
    <Fragment>
      {isLoggingOut && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <LoadingSpinner />
          <p style={{
            color: 'white',
            marginTop: '20px',
            fontSize: '18px',
            fontWeight: 600
          }}>
            Logging out...
          </p>
        </div>
      )}
      {/* Header first row for logo, search, theme toggle and user icon */}
      <ReadOnlyTransaction
        getQAFeatureFlagsRequest = {props.getQAFeatureFlagsRequest}
        reviewEntities = {props.reviewEntities}
        getQAErrors = {props.getQAErrors}
        getTransactionDocuments = {props.getTransactionDocuments}
      />
      <AutoLogoutTimeOut />
      {showUserPrefs && props.preferenceValues && props.preferences && <UserPreferences
        preferences={props.preferences}
        close={() => {setShowUserPrefs(false)}}
        savePreferences={savePreferences}
        zoomLevels={props.preferenceValues.find(x => x.settingID == 2).values.map(x => x.settingValue)}
      />}
      <div className="common-row-level-margin" id="header-row" style={{alignItems: "center", display: "flex", flexWrap: "nowrap", padding: "20px 15px 0 15px"}}>
        <div style={{ flexGrow: "1" }}>
          <Link className="logo-button" onClick={() => exitTransaction()} to="#">
            <img src={VerismaLogo} style={{width: "153px", height: "42px"}} alt="Logo" />
          </Link>
        </div>
        <div style={{ flexShrink: "1" }}>
          <div>
            <Form inline onSubmit={e => e.preventDefault()}>
              <div className="Oval-text-box" title={allowReadOnly ? "Click this toggle to search pending only (faster)" : "Click this toggle to search across all statuses (slower)"}>
                <div className="sa-btn-circle" onClick={onAllowReadOnlyChange}>
                  <div className="sa-toggler">
                    <div className={"sa-circle" + (allowReadOnly ? "" : " switched")}></div>
                    <div className="sa-off">&nbsp;</div>
                    <div className="sa-on">&nbsp;</div>
                  </div>
                </div>
                <div className="Oval-text-box-inner">
                  <input
                    type="text"
                    id="Search"
                    className=""
                    placeholder={allowReadOnly ? "Search all statuses..." : "Search pending only..."}
                    onChange={(e) => setSearchText(e.target.value.trim())}
                    value={searchText}
                  ></input>

                </div>
                <button className="btn search-btn" onClick={() => onClickSearch()}>
                  Search
                </button>

              </div>

            </Form>
          </div>
          <div>
            {searchErrorMessage.length > 0 ?
              <div className="searchErrorMsg" style={{ 'marginLeft': "50px", position: "absolute" }}>{searchErrorMessage}</div>
              : null
            }  
          </div>
        </div>
           <a
          href="#!"
          onClick={async (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            try {
              const response = await fetch(ApiUrl() + "auth/advancedsearch?userId=" + props.userState.userID, {
                method: "GET",
                credentials: "include"
              });

              if (response.ok && response.status === 200) {
                const json = await response.json();
                if (json.url) {
                  window.location.replace(json.url);
                }
              }
            } catch (error) {
              console.error("Error navigating to Advanced Search:", error);
            }
          }}
          style={{marginLeft: "21px", textDecoration: "none", cursor: "pointer"}}
        >
            <img src={magnifying_glass_small_outline} style={{marginRight: "5px"}} />
            <span className="advanced-search-label" style={{textDecoration: "underline", fontSize: "12px", lineHeight: "12px", fontWeight: 600}}>Advanced Search</span>
        </a>
        {props.finalQaFeature && <div style={{ flexShrink: "1" }}>
          <button className="btn" type="button" onClick={() => GetNextQATransactionClick()} style={{ marginLeft: "21px", height: "40px" }}>
            <img src={urgent_outline_large} style={{ marginRight: "5px" }} />
            Final QA
          </button>
        </div>}
        <div style={{ flexShrink: "1" }}>
          <div className="dm-btn-circle" onClick={onValueChange}>
            <div className="dm-toggler">
              <div className="dm-circle"></div>
              <img className='day-logo' src={DayIcon} alt={'Day Mode'} />
              <img className='night-logo' src={NightIcon} alt={'Night Mode'} />
            </div>
          </div>
        </div>
        <div style={{ flexShrink: "1" }}>
          <Navbar>
          <Nav className="ml-auto">
          <Dropdown>
            <Dropdown.Toggle as={CustomHelpToggle} id="dropdown-custom-components" >
            </Dropdown.Toggle>
            <Dropdown.Menu align={"right"}>
              <Dropdown.Item onClick={() => window.open("https://verismahelpdesk.blob.core.windows.net/public-share/WPSInstall.exe")}><a href="#!">Install Web Print/Scan App</a></Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          </Nav>
          </Navbar>
        </div>
        <div style={{ flexShrink: "1", paddingLeft: "10px" }}>
          <Navbar>
            <Nav className="ml-auto">
              <Dropdown>
                <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                </Dropdown.Toggle>
                <Dropdown.Menu align={"right"}>
                  <Dropdown.Item onClick={openPreferences}>
                    Preferences
                  </Dropdown.Item>
                  <Dropdown.Item onClick={logOut}>
                    Log Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar>
        </div>
      </div>

      {showSearchGrid ?
        <NormalTable
          onTableRowClickHandler={onSearchTableRowClickHandler}
          setGrid={setSearchGrid}
          rows={tableData}
          headCells={headCellsSearch}
          defaultSortCol="patientName"
          transactionSearchResultsStatus={props.transactionSearchResultsStatus}
          cssName="table-backdrop"
          searchTablecss="search-table"
          headerSearch={true}
        />
        : null}

      {/* Header second row for page heading and breadcrumb */}
     
      <Row className="common-row-level-margin" style={{marginLeft: "14%"}}>
      
        <Col className={props.headerClassName}>
          <Navbar>
            <APIErrorPopUp />
            <ErrorMessagePopup />
            <InformationPrompt assignAPIInfo={props.assignAPIInfo} />
            <Dropdown>
              <Row>
                <Col style={{ paddingRight: 0 }}>
                  {/* <img src={DownArrow} alt='Down Arrow'></img> */}
                </Col>
              </Row>
            </Dropdown>
            <Navbar.Collapse className="justify-content-end">
              {props.previousSearchParameters && !props.readOnlyTransactionDetails && <div style={{flexGrow: 1}}>
                <button
                  onClick={() => onReturnToSearch()}
                  className="btn"
                  type="button"
                  style={{ marginRight: "auto", height: "40px" }}
                >
                  <img src={returnOutlineLarge} style={{ marginRight: "5px" }} />
                  Back to Search Results
                </button>
              </div>}
              {props.name === 'Data Entry' &&
                <Breadcrumb className="header-breadcrumb d-lg-block d-none">
                  <Breadcrumb.Item onClick={() => exitTransaction()}>
                    <img className="homeIcon" src={HomeIcon} alt="Home" />
                  </Breadcrumb.Item>
                    {props.homeText.map((homeText, index) => (
                      <Breadcrumb.Item key={`breadcrumb${index}`} onClick={() => exitTransaction(index)}>
                        <span className="breadcrumb-sub-item">
                          {homeText}
                          <i className="arrow right"></i>
                        </span>
                      </Breadcrumb.Item>
                    ))}
                </Breadcrumb>
              }
            </Navbar.Collapse>
          </Navbar>
        </Col>
      </Row>
    </Fragment>
  );
}


function mapStateToProps(state: any) {
  return {
    isDarkModeEnabled: state.headerState.isDarkModeEnabled,
    theme: state.headerState.theme,
    alertAPIFailure: state.dataEntryState?.alertAPIFailure,
    transactionSearchResults: state.landingPageState.transactionSearchResults,
    selectedHealthOrganizationDetails: state.landingPageState.selectedHealthOrganizationDetails,
    selectedFacilityDetails: state.landingPageState.selectedFacilityDetails,
    transactionSearchResultsStatus: state.landingPageState.transactionSearchResultsStatus,
    userState: state.loginState,
    assignAPIInfo: state.landingPageState.assignAPIInfo,
    existingTransactionID: state.landingPageState.transactionId,
    userPersonalInfo: state.landingPageState.userPersonalInfo,
    finalQaFeature: state.loginState.featureFlags.FinalQA,
    previousSearchParameters: state.loginState.previousSearchParameters,
    previousSearchPage: state.loginState.previousSearchPage,
    transactionId: state.landingPageState.transactionId,
    reviewEntities: state.dataEntryState.reviewEntities,
    getQAErrors: state.dataEntryState.getQAErrors,
    readOnlyTransactionDetails: state.landingPageState.readOnlyTransactionDetails,
    preferences: state.loginState.preferences,
    preferenceValues: state.loginState.preferenceValues
  };
}

export function mapDispatchToProps(dispatch: Function) {
  return {
    onChangeDarkMode: (data: boolean) => dispatch(onChangeDarkMode(data)),
    resetSelectedHealthOrganizatonDetails: () => dispatch(resetSelectedHealthOrganizatonDetails()),
    getTransactionSearchResultsRequest: (data: any) => dispatch(getTransactionSearchResultsRequest(data)),
    getTransactionSearchResultsReset: () => dispatch(getTransactionSearchResultsReset()),
    logoutUser: (action) => dispatch(logoutUserRequest(action)),
    openSearchResult: (organizationId: number, requestBufferId: number) =>
        dispatch(openSearchResultRequest(organizationId, requestBufferId)),
    getInitialsRequest: () => dispatch(getInitialsRequest()),
    onChangeDataEntryTab: (data: number) => dispatch(onChangeDataEntryTab(data, false)),
    resetDataEntryState: () => dispatch(resetDataEntryState()),
    showReadOnlyTransaction: (transactionId: string) => dispatch(showReadOnlyTransactionRequest(transactionId)),
    resetRequestContext: () => dispatch(resetRequestContext()),
    clearUserLocks: () => dispatch(clearUserLocksActionRequest()),
    returnToSearch: (organizationId?: number, requestBufferId?: number, parameters?: string, page?: number) => dispatch(returnToSearchRequest(organizationId, requestBufferId, parameters, page)),
    clearPreviousSearch: () => dispatch(clearPreviousSearch()),
    getQAErrors:() => dispatch(getQAErrorsActionCreator()),
    getTransactionDocuments: (transactionId: string) =>
      dispatch(getTransactionDocuments(transactionId)),
    getNextQATransactionCall: (data: any) => dispatch(getNextQATransaction(data)),
    changeRequestContext: (data: any) => dispatch(updateRequestContext(data)),
    refreshUserRedisCache: () => dispatch(refreshUserRedisCacheRequest()),
    savePreference: (settingValueId: number) => dispatch(savePreference(settingValueId)),
    setPreferences: (preferences: Preferences) => dispatch(setUserPreferences(preferences)),
    getPreferenceValues: () => dispatch(getPreferenceValues()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);